import { render, staticRenderFns } from "./techAchievementList.vue?vue&type=template&id=9071eaa8&scoped=true"
import script from "./techAchievementList.vue?vue&type=script&lang=js"
export * from "./techAchievementList.vue?vue&type=script&lang=js"
import style0 from "./techAchievementList.vue?vue&type=style&index=0&id=9071eaa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9071eaa8",
  null
  
)

export default component.exports